var map = {
	"./DOC.svg": 62030,
	"./DOCX.svg": 1178,
	"./GIF.svg": 36246,
	"./JPEG.svg": 34854,
	"./MOV.svg": 19794,
	"./MP4.svg": 26869,
	"./PDF.svg": 59150,
	"./PNG.svg": 54425,
	"./PPTX.svg": 27808,
	"./RAR.svg": 45139,
	"./TXT.svg": 12732,
	"./XLS.svg": 84643,
	"./XLSX.svg": 20385,
	"./ZIP.svg": 43137,
	"./add-img.svg": 81015,
	"./ai.svg": 59014,
	"./alfxzj.svg": 31957,
	"./align-center.svg": 38335,
	"./align-justify.svg": 27236,
	"./align-left.svg": 20343,
	"./align-right.svg": 3826,
	"./arrow-down.svg": 32348,
	"./base.svg": 58755,
	"./blockquote.svg": 25973,
	"./bold.svg": 28725,
	"./bullet-list.svg": 96833,
	"./cbzjpgzj.svg": 40764,
	"./cicle-left.svg": 7624,
	"./cicle-right.svg": 81175,
	"./code-block.svg": 26063,
	"./file-markdown.svg": 78060,
	"./file-pdf.svg": 8431,
	"./file-word.svg": 3351,
	"./filelink.svg": 52766,
	"./font-color.svg": 37265,
	"./font-size.svg": 69311,
	"./h1.svg": 5285,
	"./h2.svg": 73510,
	"./h3.svg": 78839,
	"./h4.svg": 33912,
	"./highlight-text.svg": 49436,
	"./horizontal-max.svg": 21649,
	"./horizontal-min.svg": 64391,
	"./italic.svg": 62204,
	"./lcgf.svg": 74884,
	"./like-fill.svg": 7625,
	"./like.svg": 77085,
	"./link.svg": 77452,
	"./more.svg": 67103,
	"./msg.svg": 30607,
	"./new-chat.svg": 45881,
	"./normal.svg": 74253,
	"./ordered-list.svg": 1984,
	"./redo.svg": 79388,
	"./send.svg": 5150,
	"./sjfxgcs.svg": 75110,
	"./sjzy.svg": 36780,
	"./strike.svg": 92418,
	"./swj.svg": 41884,
	"./sws.svg": 73221,
	"./sxzxzj.svg": 53311,
	"./task-list.svg": 64660,
	"./translate.svg": 40702,
	"./triangle-down.svg": 84969,
	"./underline.svg": 69816,
	"./undo.svg": 12006,
	"./unknown.svg": 72858,
	"./unlike-fill.svg": 95854,
	"./unlike.svg": 65404,
	"./wechat.svg": 60998,
	"./yygj.svg": 38957
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20527;